enum Trade {
  ASPHALT_PAVING = 'Asphalt / Paving',
  CABINETRY = 'Cabinetry',
  CONCRETE = 'Concrete',
  DRYWALL = 'Drywall',
  EARTHWORK = 'Earthwork',
  ELECTRICAL = 'Electrical',
  FINISHES = 'Finishes',
  FIRE_PROECTION = 'Fire Protection',
  FLOORING = 'Flooring',
  FRAMING = 'Framing',
  GENERAL_CONTRACTOR = 'General Contractor',
  HVAC = 'HVAC',
  LANDSCAPING = 'Landscaping',
  MASONRY = 'Masonry',
  PAINTING = 'Painting',
  PLUMBING = 'Plumbing',
  REMODELING = 'Remodeling',
  ROOFING = 'Roofing',
  OTHER = '(Other)',
}

export default Trade;
